module.exports = __webpack_public_path__ + "static/media/Ellipse-3.d081774d.svg";